const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlipVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M39.19,256.26H216.81L128,139.4Zm28.06-13.92L128,162.4l60.75,79.94Z",
    style: {
      fill: "#10216f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.81.26H39.19L128,117.12ZM188.75,14.18,128,94.11,67.25,14.18Z",
    style: {
      fill: "#10216f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.05,
    y: 122.04,
    width: 165.91,
    height: 11.93,
    style: {
      fill: "#10216f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlipVertical);
export default __webpack_public_path__ + "static/media/icon-flip-vertical.714e9bbe.svg";
export { ForwardRef as ReactComponent };